/* Bild-Lightbox (Groessentabelle, Garantiehinweis, ...).

   Nutzt das native <dialog>: showModal() bringt Fokusfalle, Escape und
   die inerte Seite dahinter schon mit. Geklickt wird per Delegation am
   Dokument, damit auch Dialoge funktionieren, die erst nach einem
   Variantenwechsel oder im Schnellkauf-Fenster im DOM landen. */
(() => {
  document.addEventListener('click', (event) => {
    const opener = event.target.closest?.('[data-lightbox-open]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('data-lightbox-open'));
      if (dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        dialog.showModal();
      }
      return;
    }

    if (event.target.closest?.('[data-lightbox-close]')) {
      event.target.closest('dialog')?.close();
      return;
    }

    /* Klick neben das Bild schliesst ebenfalls: das <dialog> fuellt den
       Viewport, der Inhalt sitzt im inneren Container - trifft der Klick
       das dialog selbst, war er daneben. */
    if (event.target instanceof HTMLDialogElement && event.target.classList.contains('hlb')) {
      event.target.close();
    }
  });
})();
